import { formGeneratorTypes } from "redux/reducers/form-generator/formGeneratorTypes"

const {
  ADD_INPUT,
  EDIT_INPUT,
  DEL_INPUT,
  SELECT_INPUT,
  CLEAN_SELECT_INPUT,
} = formGeneratorTypes

export const addInput = (input) => {
  return {
    type: ADD_INPUT,
    payload: input
  }
}

export const editInput = (input) => {
  return {
    type: EDIT_INPUT,
    payload: input
  }
}

export const delInput = (id) => {
  return {
    type: DEL_INPUT,
    payload: id
  }
}
export const selectInput = (id) => {
  return {
    type: SELECT_INPUT,
    payload: id
  }
}
export const cleanInput = () => {
  return {
    type: CLEAN_SELECT_INPUT,
  }
}